module.exports = __webpack_public_path__ + "img/btn-close-popup.eb21113f.png";